import React from "react";
import { MapPinIcon } from "@heroicons/react/24/outline";
import SettingsSection from "../fields/SettingsSection";
import SettingsField from "../fields/SettingsField";
import RadioGroup from "../fields/RadioGroup";
import Toggle from "../fields/Toggle";

export default function LocationSection({ form, onChange }) {
  return (
    <SettingsSection
      id="location"
      title="Location"
      icon={<MapPinIcon className="h-5 w-5 text-primary" />}
    >
      <SettingsField
        label="Units"
        htmlFor="units"
        description="Used for distances across the app."
      >
        <RadioGroup
          name="units"
          value={form.units}
          onChange={(v) => onChange("units", v)}
          options={[
            { value: "miles", label: "Miles" },
            { value: "km", label: "Kilometers" },
          ]}
        />
      </SettingsField>

      <SettingsField
        label="Map location control"
        htmlFor="showMyLocationOnMap"
        description="Show the location control button on the map to center on your position."
      >
        <Toggle
          id="showMyLocationOnMap"
          checked={form.showMyLocationOnMap}
          onChange={(v) => onChange("showMyLocationOnMap", v)}
          label="Show my location on map"
        />
      </SettingsField>

      <SettingsField
        label="Search circle visibility"
        htmlFor="showRadiusCircle"
        description="Show the search radius circle by default when you open the map."
      >
        <Toggle
          id="showRadiusCircle"
          checked={form.showRadiusCircle}
          onChange={(v) => onChange("showRadiusCircle", v)}
          label="Show search circle by default"
        />
      </SettingsField>
    </SettingsSection>
  );
}
